import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/medioCamp.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.CAMPAIGNS_CLEAR:
      return []
    case Actions.LIST_MEDIUM:
      return [...state, action.mediumbanners]
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}